import React from "react";

function Twenty() {
  return (
    <section>
      <div className="twentySection">
        <div className="textWrapperTwenty">
          <h3>
            <span className="fistLine">A battery that’s</span>
            <br />
            <span className="seconLine">all in,</span>
            <br />
            <span className="thirLIne">all day.</span>
          </h3>
        </div>
      </div>
    </section>
  );
}

export default Twenty;
